<div class="d-flex row-cols-12">
    <div class="col-12">
        <h3 class="title float-start" translate>Settings.Validation</h3>
    </div>
</div>
<div class="px-4 my-2 mb-1 d-table col-12">
    <span class="pt-5 pb-2 col-12" translate="Settings.SecuritySection.Validation.DetachedCertificate"><app-info-button
            labelName="Settings.SecuritySection.Validation.DetachedCertificateTooltip" [url]="DetachedCertificateUrl"
            placement="bottom"></app-info-button></span>
    <!-- <ul class="mb-3 mt-2 list-group">
        <li class="list-group-item subheader d-block">
            <div class="row row-cols-5 d-flex align-items-center">
                <div class="col-6 firstcol">
                </div>
                <div class="col-2"><span translate="Settings.SecuritySection.Validation.Owner"></span>
                </div>
                <div class="col-2"><span translate="Settings.SecuritySection.Validation.Internal"></span>
                </div>
                <div class="col-2"><span translate="Settings.SecuritySection.Validation.External"></span>
                </div>
            </div>
        </li>
        <li class="list-group-item d-block">
            <div class="row row-cols-12 d-flex align-items-center">
                <div class="col-6 firstcol text-truncate" translate="Settings.SecuritySection.Validation.DownloadDetachedCertificate"></div>
                <div class="col-2 firstcol text-truncate float-none form-check form-switch">
                    <input class="switch-form-default float-none form-check-input items" type="checkbox" role="switch" (change)="updateDetachedCertificate($event)" id="Owner" name="DownloadDCOwner" [checked]="detachedCertificate?.includeDetachedCertificate">
                </div>
                <div class="col-2 firstcol text-truncate float-none form-check form-switch">
                    <input class="switch-form-default float-none form-check-input items" type="checkbox" role="switch" (change)="updateDetachedCertificate($event)" id="Internal" name="DownloadDCInternal" [checked]="detachedCertificate?.includeDetachedCertificate">
                </div>
                <div class="col-2 firstcol text-truncate float-none form-check form-switch">
                    <input class="switch-form-default float-none form-check-input items" type="checkbox" role="switch"(change)="updateDetachedCertificate($event)" id="External" name="DownloadDCExternal" [checked]="detachedCertificate?.includeDetachedCertificate">
                </div>
            </div>
        </li>
    </ul> -->
    <ul class="mb-3 mt-2 list-group">
        <app-hide-by-permission-wrapper [forPermission]="permissionEnum.Perm_Generate_DC">
        <li class="list-group-item d-block">
            <div class="row row-cols-12 d-flex align-items-center">
                <div class="d-table form-check form-switch">
                    <input class="float-none switch-form-default form-check-input items" type="checkbox" role="switch"
                        (change)="updateDetachedCertificate($event)" id="detachedCertificate" name="detachedCertificate"
                        [checked]="detachedCertificate?.includeDetachedCertificate"
                        [disabledByPermission]="permissionEnum.Perm_Generate_DC">
                    <label translate="Settings.SecuritySection.Validation.DownloadDetachedCertificate"
                        for="detachedCertificate"></label>
                </div>
            </div>
        </li>
        </app-hide-by-permission-wrapper>
    </ul>
</div>